import { Component, Input } from '@angular/core';
import { DsChipColorVariant, DsChipIconPosition, DsColors, Icons, IconStyles } from '@levelaccess/design-system';

import { BaseCellComponent, ICellConfig } from '../base-cell/base-cell.component';
import { $severity } from '../../../../../../../shared/constants/accessibility';
import { ICustomSeverity } from '../../../../../../../shared/interfaces/tenant.interface';
import { SeverityClass } from '../../../../../interfaces/custom-severities.interface';
import { $customSeverity } from '../../../../../../../shared/constants/tenant';
import { SharedCommonUtility } from '../../../../../../../shared/utils/common.utility';
import { SharedTextUtility } from '../../../../../../../shared/utils/text.utility';
import { SeverityChipUtility } from '../../../../../utility/severity-chip.utility';

export interface IDSSeverityCellConfig extends ICellConfig {
  severity: $severity;
  customSeverity: ICustomSeverity;
  customSeverityKeysSortedByRank?: $severity[];
  icon?: Icons;
  class?: SeverityClass;
}

@Component({
  selector: 'table-cell-custom-severity',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  standalone: false,
  template: `
    <div #ref class="ds-severity-cell">
      <ds-chip
        [text]="severityText"
        [colorVariant]="DsChipColorVariant.Light"
        [showIcon]="true"
        [iconPosition]="DsChipIconPosition.Left"
        [iconName]="getSeverityIconName()"
        [iconStyle]="IconStyles.Regular"
        [iconColor]="getSeverityIconColor(config.severity)"
      ></ds-chip>
    </div>
  `,
})
export class DsSeverityCellComponent extends BaseCellComponent {
  protected readonly Icons: typeof Icons = Icons;
  protected readonly IconStyles: typeof IconStyles = IconStyles;
  protected readonly DsChipColorVariant: typeof DsChipColorVariant = DsChipColorVariant;
  protected readonly DsChipIconPosition: typeof DsChipIconPosition = DsChipIconPosition;

  @Input() public config: IDSSeverityCellConfig;

  protected get severityText(): string {
    return SharedCommonUtility.notNullishOrEmpty(this.config.text)
      ? this.config.text
      : SharedTextUtility.capitalize(this.config.customSeverity?.[$customSeverity.label]);
  }

  public getSeverityIconColor(severity: $severity): keyof typeof DsColors {
    return SeverityChipUtility.getIconColor(severity, { defaultColor: 'Info' });
  }

  public getSeverityIconName(): Icons {
    return SeverityChipUtility.getIcon(this.config.severity, {
      icon: this.config.icon,
      customSeverityKeysSortedByRank: this.config.customSeverityKeysSortedByRank,
    });
  }
}
